export const globalOnApplyFilters = (
  setPageFunction: (page: number) => void,
  apiCallFunction: (params: any) => void,
  filters: any,
  page: number
) => {
  setPageFunction(page);
  let newFilter = filterTrimValue(filters);
  let params = { ...newFilter, page: 0 };
  apiCallFunction(params);
};

export const filterTrimValue = (filters: any) => {
  let newFilter: any = {};
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== "") {
      if (typeof filters[key] === "string") {
        newFilter[key] = filters[key].trim();
      } else {
        newFilter[key] = filters[key];
      }
    }
  });
  return newFilter;
};
